import React from "react";
import ChangeLanguage from "./ChangeLanguage/ChangeLanguage";
import "./Header.scss";
import Image from "../../Components/Image/Image";
import { useAppDispatch, useAppSelector } from "../../Redux/store";
import { overallActions } from "../services/slice";
import { pageBookingEnum } from "../../Types/routes.type";
import defaultLogoTop from "./assets/logo-top.png";
import {getImageUrl} from "../../Util/Util";

const Header = () => {
    const dispatch = useAppDispatch();
    const branch = useAppSelector((state) => state.overall.branch);

    const goHome = function () {
        dispatch(overallActions.setPageBooking(pageBookingEnum.ticket));
    };



    // Nếu dùng fallback
    const logoTop = getImageUrl(branch?.logo_header, defaultLogoTop);
    const headerBgColor =
         branch && branch.header_bg_color
            ? branch.header_bg_color
            : "#000000"; // fallback màu

    return (
        <div
            className="layout-header"
            style={{ backgroundColor: headerBgColor }}
        >
            <Image
                onClick={goHome}
                className="layout-header-logo"
                style={{
                    backgroundImage: logoTop ? 'url("' + logoTop + '")' : undefined,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                }}
            />
            <ChangeLanguage />
        </div>
    );
};

export default React.memo(Header);
